import React from 'react';

import { Kontact } from '@/app/_components/Kontact';
import { KontactProps } from './types';

import classes from './index.module.scss';

export const KontactGraphQL: React.FC<KontactProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <Kontact kontact={props} />
    </div>
  );
};

export default KontactGraphQL;
